import { ConversationMessageContent } from '@modules/conversation-message/ConversationMessageContent';
import { IconButton, MenuItem, styled } from '@mui/material';

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  position: 'relative',
  height: 'auto',
  alignItems: 'start',
  display: 'flow',
  marginBottom: theme.spacing(2),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1),
  '&.readed': {
    background: theme.palette.background.support,
  },
  '& .MuiIconButton-root': {
    visibility: 'hidden',
  },
  '&:hover': {
    '& .MuiIconButton-root': {
      visibility: 'inherit',
    },
  },
}));

export const StyledRemoveIcon = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(0.5),
  right: theme.spacing(1),
}));

export const ChatMessageContentStyled = styled(ConversationMessageContent)(
  () => ({
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    '& div': {
      maxWidth: '100%',
    },
    '& p': {
      whiteSpace: 'normal',
    },
  }),
);
